import { createContext, useContext, type Context } from 'react';

type HamPermissionId = 'manage-ham' | 'view-ham' | 'jsd-user' | 'jira-admin' | 'assets-admin';

export type HamPermissionChecksResult = {
	readonly assetsVerticalWorkspaceAri: string | null;
	readonly permissions: Readonly<Record<HamPermissionId, boolean>>;
};

export type ItamPermissionsContextValue = {
	/** Resolved HAM permission checks, or `null` while still loading / when unavailable. */
	readonly data: HamPermissionChecksResult | null;
	/** True while the dependent HAM permission checks are still resolving. */
	readonly loading: boolean;
};

const DEFAULT_VALUE: ItamPermissionsContextValue = {
	data: null,
	loading: false,
};

export const ItamPermissionsContext: Context<ItamPermissionsContextValue> =
	createContext<ItamPermissionsContextValue>(DEFAULT_VALUE);

export const useItamPermissionsContext = (): ItamPermissionsContextValue =>
	useContext(ItamPermissionsContext);
